// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.syntax-token--punctuation {
  color: var(--color-syntax-punctuation);
}
.syntax-token--operator {
  color: var(--color-syntax-operator);
}
.syntax-token--comment {
  color: var(--color-syntax-comment);
}
.syntax-token--shebang {
  color: var(--color-syntax-shebang);
}
.syntax-token--keyword {
  color: var(--color-syntax-keyword);
}
.syntax-token--key {
  color: var(--color-syntax-key);
}
.syntax-token--property {
  color: var(--color-syntax-property);
}
.syntax-token--string {
  color: var(--color-syntax-string);
}
.syntax-token--template-string {
  color: var(--color-syntax-template-string);
}
.syntax-token--triple-quoted-string {
  color: var(--color-syntax-triple-quoted-string);
}
.syntax-token--scalar {
  color: var(--color-syntax-scalar);
}
.syntax-token--number {
  color: var(--color-syntax-number);
}
.syntax-token--boolean {
  color: var(--color-syntax-boolean);
}
.syntax-token--regex {
  color: var(--color-syntax-regex);
}
.syntax-token--variable {
  color: var(--color-syntax-variable);
}
.syntax-token--null {
  color: var(--color-syntax-null);
}
.syntax-token--builtin {
  color: var(--color-syntax-builtin);
}
.syntax-token--class-name {
  color: var(--color-syntax-class-name);
}
.syntax-token--function {
  color: var(--color-syntax-function);
}
.syntax-token--coord {
  color: var(--color-syntax-coord);
}
.syntax-token--diff {
  color: var(--color-syntax-diff);
}
.syntax-token--inserted {
  color: var(--color-syntax-inserted);
}
.syntax-token--deleted {
  color: var(--color-syntax-deleted);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/syntax-highlighter/TokenRenderer.less"],"names":[],"mappings":"AACE;EAAiB,sCAAA;AACnB;AAAE;EAAc,mCAAA;AAGhB;AAFE;EAAa,kCAAA;AAKf;AAJE;EAAa,kCAAA;AAOf;AANE;EAAa,kCAAA;AASf;AARE;EAAS,8BAAA;AAWX;AAVE;EAAc,mCAAA;AAahB;AAZE;EAAY,iCAAA;AAed;AAdE;EAAqB,0CAAA;AAiBvB;AAhBE;EAA0B,+CAAA;AAmB5B;AAlBE;EAAY,iCAAA;AAqBd;AApBE;EAAY,iCAAA;AAuBd;AAtBE;EAAa,kCAAA;AAyBf;AAxBE;EAAW,gCAAA;AA2Bb;AA1BE;EAAc,mCAAA;AA6BhB;AA5BE;EAAU,+BAAA;AA+BZ;AA9BE;EAAa,kCAAA;AAiCf;AAhCE;EAAgB,qCAAA;AAmClB;AAlCE;EAAc,mCAAA;AAqChB;AApCE;EAAW,gCAAA;AAuCb;AAtCE;EAAU,+BAAA;AAyCZ;AAxCE;EAAc,mCAAA;AA2ChB;AA1CE;EAAa,kCAAA;AA6Cf","sourcesContent":[".syntax-token {\n  &--punctuation { color: var(--color-syntax-punctuation); }\n  &--operator { color: var(--color-syntax-operator); }\n  &--comment { color: var(--color-syntax-comment); }\n  &--shebang { color: var(--color-syntax-shebang); }\n  &--keyword { color: var(--color-syntax-keyword); }\n  &--key { color: var(--color-syntax-key); }\n  &--property { color: var(--color-syntax-property); }\n  &--string { color: var(--color-syntax-string); }\n  &--template-string { color: var(--color-syntax-template-string); }\n  &--triple-quoted-string { color: var(--color-syntax-triple-quoted-string); }\n  &--scalar { color: var(--color-syntax-scalar); }\n  &--number { color: var(--color-syntax-number); }\n  &--boolean { color: var(--color-syntax-boolean); }\n  &--regex { color: var(--color-syntax-regex); }\n  &--variable { color: var(--color-syntax-variable); }\n  &--null { color: var(--color-syntax-null); }\n  &--builtin { color: var(--color-syntax-builtin); }\n  &--class-name { color: var(--color-syntax-class-name); }\n  &--function { color: var(--color-syntax-function); }\n  &--coord { color: var(--color-syntax-coord); }\n  &--diff { color: var(--color-syntax-diff); }\n  &--inserted { color: var(--color-syntax-inserted); }\n  &--deleted { color: var(--color-syntax-deleted); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
